<template>
    <div class="store-list">
        <load-more ref="storeList" :list="lstStore">
            <ul slot-scope="props">
                <li v-for="(addr, index) in props.data" :key="addr.code">
                    <div class="addr-link">
                        <div class="info">
                            <h4>
                                <span
                                    v-if="addr.storeType"
                                    class="type"
                                    :style="{ background: addr.displayCloseReason ? '#808080' : getStoreColor(addr.storeType) }"
                                    >{{ addr.storeType | storeNameFormat }}</span
                                >
                                <span class="title">{{ addr.name }} </span>
                                <span v-show="index === 0" class="closest">距离最近</span>
                            </h4>
                            <p class="txt-address">
                                {{ addr.address }}
                            </p>
                            <p v-if="addr.displayCloseReason" class="time">
                                <img class="reason" src="@/assets/images/ico/reason.png" alt="服务情况" /><span>服务情况：</span>
                                <span class="red">{{ addr.displayCloseReason }}</span>
                            </p>
                            <p v-else class="time">
                                <span v-if="addr.serviceTime"></span>
                                {{ addr.serviceTime }}
                            </p>
                            <p v-if="addr.storeType === '5'" class="time">
                                <span>24小时营业</span>
                            </p>
                            <a v-if="addr.tel" class="tel" :href="`tel:${addr.tel}`" @click.stop>
                                <i class="icon-contact"></i>
                                <span>{{ addr.tel }}</span>
                            </a>
                        </div>
                        <div class="gis">
                            <i class="icon-gis"></i>
                            <p>{{ addr.distinct | distinctFormat }}</p>
                            <div class="map-nav" @click="navigate(index)">地图显示</div>
                        </div>
                    </div>
                </li>
            </ul>
        </load-more>
        <slot />
    </div>
</template>

<script>
import LoadMore from '../load-more'
import { STORE_TYPE } from '@uip-alpha/business-constants'

export default {
    name: 'StoreList',
    components: {
        'load-more': LoadMore
    },
    filters: {
        distinctFormat(val) {
            return val > 1000 ? `${(val / 1000 || 0).toFixed(2)}k` : `${val}m`
        },
        storeNameFormat(type) {
            return {
                [STORE_TYPE.SITE]: '网点',
                [STORE_TYPE.SHOP]: '商家',
                [STORE_TYPE.YX]: '商家',
                [STORE_TYPE.STATION]: '网点',
                [STORE_TYPE.FC]: '丰巢',
                6: '' // 默认样式，不显示服务店名称
            }[type || '6']
        }
    },
    props: {
        lstStore: {
            type: Array,
            required: true
        }
    },
    methods: {
        getStoreColor(type) {
            const [, bgColor] = {
                [STORE_TYPE.SITE]: ['网点', '#FF3A3A'],
                [STORE_TYPE.SHOP]: ['商家', '#0579FE'],
                [STORE_TYPE.YX]: ['商家', '#0579FE'],
                [STORE_TYPE.STATION]: ['网点', '#FF3A3A'],
                [STORE_TYPE.FC]: ['丰巢', '#FFB800'],
                6: [] // 默认样式，不显示服务店名称
            }[type || '6']
            return bgColor
        },
        navigate(index) {
            this.$emit('navigate', index)
        }
    }
}
</script>

<style lang="scss" scoped>
.store-list {
    height: 80%;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 3.2%;
    background: #f5f4f5;
    ul {
        padding-top: 0.24rem;
        li {
            padding: 0.1rem 0.2rem;
            border-bottom: solid 1px #efefef;
            background: #fff;
            margin-bottom: 0.24rem;
            box-shadow: 0px 0px 0.29rem rgba(0, 0, 0, 0.0388986);
            border-radius: 0.26rem;
            padding: 0.36rem 0.3rem;
            position: relative;
            .icon-contact {
                display: inline-block;
                vertical-align: bottom;
                width: 0.24rem;
                height: 0.24rem;
                background: url('~@/assets/images/ico/ico-cell.svg') center / cover;
                margin-right: 0.04rem;
            }
            &:first-child .addr-link .info .title {
                max-width: 3rem;
            }
        }
    }
    .closest {
        background: rgba(255, 58, 58, 0.1);
        border-radius: 0.08rem;
        padding: 0.02rem 0.12rem;
        font-weight: 600;
        font-size: 0.24rem;
        line-height: 0.36rem;
        margin-left: 0.16rem;
        color: #ff3a3a;
    }
    .addr-link {
        display: flex;
        justify-items: center;
        .info {
            flex: 1;
            width: 5rem;
            /* line-height: 2; */
            color: #666;
            .title {
                font-weight: bold;
                font-size: 0.32rem;
                vertical-align: middle;
                color: #0f1214;
                line-height: 0.46rem;
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 4.5rem;
            }
            .type {
                color: #fff;
                font-size: 0.24rem;
                padding: 0.08rem 0.1rem;
                border-radius: 0.1rem;
                vertical-align: middle;
            }
            .tel {
                display: block;
                color: #808080;
                margin-top: 0.16rem;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.28rem;
            }
            .txt-address {
                width: 5rem;
                display: -webkit-box;
                -webkit-box-lines: 2;
                -webkit-box-orient: vertical;
                margin-top: 0.22rem;
                line-height: normal;
                font-weight: 400;
                font-size: 0.26rem;
                line-height: 0.36rem;
                color: #0f1214;
            }
            .time {
                color: #808080;
                margin-top: 0.22rem;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.28rem;
                padding-left: 0.38rem;
                background: url('~@/assets/images/ico/time.png') left -0.01rem / 0.32rem no-repeat;
            }
        }
        .red {
            color: $red;
        }
        .gis {
            width: 1rem;
            text-align: center;
            position: relative;
            .icon-gis {
                display: inline-block;
                vertical-align: middle;
                width: 0.62rem;
                height: 0.62rem;
                background: #f5f4f5 url('~@/assets/images/ico/icon-location.png') center / 0.32rem no-repeat;
                border-radius: 50%;
            }
            p {
                margin-top: 0.06rem;
                font-size: 0.28rem;
                font-weight: 400;
                font-size: 0.22rem;
                line-height: 0.3rem;
                color: #808080;
            }
            .map-nav {
                font-weight: 400;
                font-size: 0.22rem;
                line-height: 0.22rem;
                text-align: center;
                color: #0f1214;
                position: absolute;
                bottom: 0;
                right: 0;
                width: 100%;
            }
        }
        .reason {
            width: 0.3rem;
            vertical-align: bottom;
            margin-right: 0.1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/store/components/storeList/index.vue